module.exports = __webpack_public_path__ + "static/media/clinica.42daa67e.svg";